var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20861 7.43123H21.7914C23.0092 7.43123 24 6.44043 24 5.22262C24 4.00326 23.0092 3.01251 21.7914 3.01251H2.20861C0.990797 3.01251 0 4.00326 0 5.22262C0 6.44043 0.990797 7.43123 2.20861 7.43123ZM2.20861 4.41876H21.7914C22.2338 4.41876 22.5938 4.77872 22.5938 5.22112C22.5938 5.66508 22.2338 6.02498 21.7914 6.02498H2.20861C1.7662 6.02498 1.40625 5.66503 1.40625 5.22112C1.40625 4.77867 1.7662 4.41876 2.20861 4.41876Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7914 9.79063H2.20861C0.990797 9.79063 0 10.7814 0 12.0007C0 13.2186 0.990797 14.2094 2.20861 14.2094H21.7914C23.0092 14.2094 24 13.2186 24 12.0007C24 10.7814 23.0092 9.79063 21.7914 9.79063ZM21.7914 12.8031H2.20861C1.7662 12.8031 1.40625 12.4431 1.40625 11.9992C1.40625 11.5568 1.7662 11.1969 2.20861 11.1969H21.7914C22.2338 11.1969 22.5938 11.5568 22.5938 11.9992C22.5938 12.4432 22.2338 12.8031 21.7914 12.8031Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7914 16.5688H2.20861C0.990797 16.5688 0 17.5596 0 18.7789C0 19.9967 0.990797 20.9875 2.20861 20.9875H21.7914C23.0092 20.9875 24 19.9967 24 18.7789C24 17.5596 23.0092 16.5688 21.7914 16.5688ZM21.7914 19.5812H2.20861C1.7662 19.5812 1.40625 19.2213 1.40625 18.7774C1.40625 18.335 1.7662 17.975 2.20861 17.975H21.7914C22.2338 17.975 22.5938 18.335 22.5938 18.7774C22.5938 19.2213 22.2338 19.5812 21.7914 19.5812Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.a0f5073702e4de33b90ca9576d9c54c9.svg";
export { ForwardRef as ReactComponent };